// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../utils/colors.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/bgTry5.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  font-family: 'Montserrat', 'Segoe UI', sans-serif;
}

.auth-container {
  display: flex;
  width: 72%;
  max-width: 1100px;
  min-height: 82vh;
  border-radius: 16px;
  overflow: hidden;
  box-shadow:
    0 14px 28px rgba(0, 0, 0, 0.85),
    0 10px 10px rgba(0, 0, 0, 0.85);
}

/* ── Left info panel ── */
.info-panel {
  width: 50%;
  background: var(--auth-overlay-bg);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;
}

.info-panel h1 {
  font-size: 1.9rem;
  font-weight: 700;
  color: #fff;
  margin: 0 0 32px;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
}

.info-panel p {
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.88);
  margin: 0;
}

/* ── Right form panel ── */
.form-panel {
  width: 50%;
  background: var(--auth-form-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

/* ── Input / select styles ── */
.form-panel input,
.form-panel select,
.form-panel textarea {
  background: var(--auth-input-bg) !important;
  border: 1px solid var(--auth-input-border) !important;
  border-radius: 8px !important;
  color: var(--auth-input-text) !important;
  transition: border-color 0.2s !important;
}

.form-panel input::placeholder,
.form-panel select::placeholder {
  color: var(--auth-input-placeholder) !important;
}

.form-panel input:focus,
.form-panel select:focus,
.form-panel textarea:focus {
  outline: none !important;
  border-color: var(--auth-input-border-focus) !important;
  box-shadow: 0 0 0 2px rgba(225, 6, 19, 0.18) !important;
}

.form-panel h2,
.form-panel h3 {
  color: var(--auth-title);
}

.form-panel label {
  color: var(--auth-subtitle) !important;
}

.form-panel button[type="submit"] {
  background: var(--map-danger-gradient) !important;
  color: #fff !important;
  border: none !important;
  border-radius: 24px !important;
  font-weight: 700 !important;
  letter-spacing: 1.4px !important;
  cursor: pointer !important;
  transition: opacity 0.2s, transform 0.1s !important;
}

.form-panel button[type="submit"]:hover { opacity: 0.9 !important; }
.form-panel button[type="submit"]:active { transform: scale(0.97) !important; }

.form-panel select { color-scheme: dark; }

.form-panel svg {
  color: var(--auth-input-placeholder);
  transition: color 0.2s;
}
.form-panel svg:hover { color: var(--map-danger); }

.form-panel .phone-prefix,
.form-panel [class*="phone"],
.form-panel [class*="flag"] {
  background: var(--auth-input-bg) !important;
  border: 1px solid var(--auth-input-border) !important;
  border-radius: 8px !important;
  color: var(--auth-input-text) !important;
}

/* ── Back button ── */
.back-btn {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 24px;
  padding: 10px 20px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  cursor: pointer;
  backdrop-filter: blur(6px);
  transition: background 0.2s, border-color 0.2s;
}

.back-btn:hover {
  background: rgba(238, 91, 67, 0.7);
  border-color: rgba(238, 91, 67, 0.8);
}

/* ── Mobile ── */
@media (max-width: 600px) {
  .auth-container {
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    border-radius: 0;
  }

  .info-panel {
    width: 100%;
    padding: 32px 24px;
    min-height: auto;
  }

  .form-panel {
    width: 100%;
    padding: 24px 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/templates/loginTemplate/LoginTemplate.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yDAA2D;EAC3D,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB;;mCAEiC;AACnC;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,UAAU;EACV,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,gCAAgC;AAChC;;;EAGE,2CAA2C;EAC3C,qDAAqD;EACrD,6BAA6B;EAC7B,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;;;EAGE,wBAAwB;EACxB,uDAAuD;EACvD,uDAAuD;AACzD;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,mDAAmD;AACrD;;AAEA,0CAA0C,uBAAuB,EAAE;AACnE,2CAA2C,iCAAiC,EAAE;;AAE9E,qBAAqB,kBAAkB,EAAE;;AAEzC;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA,wBAAwB,wBAAwB,EAAE;;AAElD;;;EAGE,2CAA2C;EAC3C,qDAAqD;EACrD,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE;IACE,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":["@import '../../utils/colors.css';\n\n.auth-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-image: url(\"../../../public/images/bgTry5.webp\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  font-family: 'Montserrat', 'Segoe UI', sans-serif;\n}\n\n.auth-container {\n  display: flex;\n  width: 72%;\n  max-width: 1100px;\n  min-height: 82vh;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow:\n    0 14px 28px rgba(0, 0, 0, 0.85),\n    0 10px 10px rgba(0, 0, 0, 0.85);\n}\n\n/* ── Left info panel ── */\n.info-panel {\n  width: 50%;\n  background: var(--auth-overlay-bg);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  text-align: center;\n}\n\n.info-panel h1 {\n  font-size: 1.9rem;\n  font-weight: 700;\n  color: #fff;\n  margin: 0 0 32px;\n  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);\n}\n\n.info-panel p {\n  font-size: 14px;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.88);\n  margin: 0;\n}\n\n/* ── Right form panel ── */\n.form-panel {\n  width: 50%;\n  background: var(--auth-form-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n}\n\n/* ── Input / select styles ── */\n.form-panel input,\n.form-panel select,\n.form-panel textarea {\n  background: var(--auth-input-bg) !important;\n  border: 1px solid var(--auth-input-border) !important;\n  border-radius: 8px !important;\n  color: var(--auth-input-text) !important;\n  transition: border-color 0.2s !important;\n}\n\n.form-panel input::placeholder,\n.form-panel select::placeholder {\n  color: var(--auth-input-placeholder) !important;\n}\n\n.form-panel input:focus,\n.form-panel select:focus,\n.form-panel textarea:focus {\n  outline: none !important;\n  border-color: var(--auth-input-border-focus) !important;\n  box-shadow: 0 0 0 2px rgba(225, 6, 19, 0.18) !important;\n}\n\n.form-panel h2,\n.form-panel h3 {\n  color: var(--auth-title);\n}\n\n.form-panel label {\n  color: var(--auth-subtitle) !important;\n}\n\n.form-panel button[type=\"submit\"] {\n  background: var(--map-danger-gradient) !important;\n  color: #fff !important;\n  border: none !important;\n  border-radius: 24px !important;\n  font-weight: 700 !important;\n  letter-spacing: 1.4px !important;\n  cursor: pointer !important;\n  transition: opacity 0.2s, transform 0.1s !important;\n}\n\n.form-panel button[type=\"submit\"]:hover { opacity: 0.9 !important; }\n.form-panel button[type=\"submit\"]:active { transform: scale(0.97) !important; }\n\n.form-panel select { color-scheme: dark; }\n\n.form-panel svg {\n  color: var(--auth-input-placeholder);\n  transition: color 0.2s;\n}\n.form-panel svg:hover { color: var(--map-danger); }\n\n.form-panel .phone-prefix,\n.form-panel [class*=\"phone\"],\n.form-panel [class*=\"flag\"] {\n  background: var(--auth-input-bg) !important;\n  border: 1px solid var(--auth-input-border) !important;\n  border-radius: 8px !important;\n  color: var(--auth-input-text) !important;\n}\n\n/* ── Back button ── */\n.back-btn {\n  position: fixed;\n  top: 20px;\n  left: 20px;\n  z-index: 1000;\n  background: rgba(0, 0, 0, 0.5);\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 24px;\n  padding: 10px 20px;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  backdrop-filter: blur(6px);\n  transition: background 0.2s, border-color 0.2s;\n}\n\n.back-btn:hover {\n  background: rgba(238, 91, 67, 0.7);\n  border-color: rgba(238, 91, 67, 0.8);\n}\n\n/* ── Mobile ── */\n@media (max-width: 600px) {\n  .auth-container {\n    flex-direction: column;\n    width: 100%;\n    min-height: 100vh;\n    border-radius: 0;\n  }\n\n  .info-panel {\n    width: 100%;\n    padding: 32px 24px;\n    min-height: auto;\n  }\n\n  .form-panel {\n    width: 100%;\n    padding: 24px 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
